import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import ObrasService from '../../../../services/obras-auth';
import Obra from './obra';
import Moment from 'moment';


const ListarObras = () => {

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const [obras, setObras] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [obra, setObr] = useState("");


    async function fetchObras() {
        const response = await ObrasService.listar();
        if (response.data.length >= 1) {
            setObras(response.data)
            setVazio(false)
        } else {
            setObras([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setObr(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a obra?')) {
            await ObrasService.deletar(id)
            alert("Obra deletada com sucesso!")
            fetchObras();
        }
    }

    useEffect(() => {
        fetchObras();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/obras/editar/${obra}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setObras={setObras}
                        setVazio={setVazio}
                        fetchObras={fetchObras}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {obras.map((obr, index) =>
                                <Obra
                                    fetchObras={fetchObras}
                                    obr={obr}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarObras;